import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-helpicon',
  imports: [CommonModule],
  templateUrl: './helpicon.html',
  styleUrl: './helpicon.scss',
})
export class Helpicon {}
